import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "text-body-1" }
const _hoisted_3 = { class: "text-body-1" }
const _hoisted_4 = { class: "text-body-1" }
const _hoisted_5 = { class: "text-body-1" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-body-1" }
const _hoisted_9 = { class: "text-body-1" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "text-body-1" }
const _hoisted_13 = { class: "text-body-1" }
const _hoisted_14 = { class: "mb-6" }
const _hoisted_15 = { class: "text-body-1" }
const _hoisted_16 = { class: "d-flex flex-wrap ga-2" }
const _hoisted_17 = { class: "text-body-1" }
const _hoisted_18 = { class: "text-body-1" }
const _hoisted_19 = { class: "text-body-1" }
const _hoisted_20 = { class: "text-body-1 font-weight-bold" }


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestDetailsDialog',
  props: {
    request: {}
  },
  emits: ["close", "fill-request", "mark-delivered"],
  setup(__props: any) {

/* eslint-disable no-undef */




const formatEquipmentType = (type: string) => {
  if (!type) return 'Unknown'
  return type.charAt(0).toUpperCase() + type.slice(1)
}

const formatStatus = (status: string) => {
  if (!status) return 'Unknown'
  return status.split('_').map(word =>
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ')
}

const formatTask = (task: string) => {
  if (!task) return ''
  return task.split('_').map(word =>
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ')
}

const formatDateTime = (date: string) => {
  if (!date) return 'N/A'
  return new Date(date).toLocaleString()
}

const getStatusColor = (status: string) => {
  const statusColors: Record<string, string> = {
    pending: 'warning',
    under_review: 'info',
    approved: 'success',
    fulfilled: 'success',
    filled: 'info',
    completed: 'success',
    delivered: 'success',
    cancelled: 'error',
    denied: 'error'
  }
  return statusColors[status] || 'grey'
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": !!__props.request,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
    "max-width": "800px"
  }, {
    default: _withCtx(() => [
      (__props.request)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-h5" }, "Request Details", -1)),
                  _createVNode(_component_v_btn, {
                    icon: "mdi-close",
                    variant: "text",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, { class: "pa-6" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-h6 mb-3" }, "Student Information", -1)),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Name", -1)),
                            _createElementVNode("div", _hoisted_2, _toDisplayString(__props.request.student_name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "School", -1)),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.request.school_name || __props.request.school), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Grade", -1)),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.request.grade_level || 'N/A'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Contact Email", -1)),
                            _createElementVNode("div", _hoisted_5, [
                              (__props.request.contact_email)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: `mailto:${__props.request.contact_email}`,
                                    class: "text-primary text-decoration-none"
                                  }, _toDisplayString(__props.request.contact_email), 9, _hoisted_6))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, "N/A"))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Contact Phone", -1)),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.request.contact_phone || 'N/A'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Teacher's Email", -1)),
                            _createElementVNode("div", _hoisted_9, [
                              (__props.request.teacher_email)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: `mailto:${__props.request.teacher_email}`,
                                    class: "text-primary text-decoration-none"
                                  }, _toDisplayString(__props.request.teacher_email), 9, _hoisted_10))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, "N/A"))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Assignee", -1)),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(__props.request.assignee_name || 'None'), 1)
                          ]),
                          _: 1
                        }),
                        (__props.request.technology_access)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Current Access to Technology at Home", -1)),
                                _createElementVNode("div", _hoisted_13, _toDisplayString(__props.request.technology_access), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_divider, { class: "my-4" }),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-h6 mb-3" }, "Equipment Request", -1)),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Equipment Type", -1)),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(formatEquipmentType(__props.request.equipment_type)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Minimum Rating", -1)),
                            _createVNode(_component_v_chip, {
                              color: "primary",
                              size: "small",
                              class: "mt-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.request.minimum_rating || 'N/A'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-2" }, "Needed For (Tasks)", -1)),
                            _createElementVNode("div", _hoisted_16, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.needed_for, (task) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  key: task,
                                  size: "small",
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(formatTask(task)), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }),
                        (__props.request.work_description)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Work Description", -1)),
                                _createElementVNode("div", _hoisted_17, _toDisplayString(__props.request.work_description), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (__props.request.additional_comments)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Additional Comments", -1)),
                                _createElementVNode("div", _hoisted_18, _toDisplayString(__props.request.additional_comments), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_divider, { class: "my-4" }),
                  _createElementVNode("div", null, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-h6 mb-3" }, "Status", -1)),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Current Status", -1)),
                            _createVNode(_component_v_chip, {
                              color: getStatusColor(__props.request.status),
                              size: "small",
                              class: "mt-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(formatStatus(__props.request.status)), 1)
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6"
                        }, {
                          default: _withCtx(() => [
                            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Submitted", -1)),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(formatDateTime(__props.request.submitted_at)), 1)
                          ]),
                          _: 1
                        }),
                        (__props.request.assigned_asset_tag)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Assigned Equipment", -1)),
                                _createElementVNode("div", _hoisted_20, _toDisplayString(__props.request.assigned_asset_tag), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  (__props.request.status === 'pending' && !__props.request.assigned_equipment_id)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "primary",
                        variant: "flat",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('fill-request', __props.request)))
                      }, {
                        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                          _createTextVNode(" Fill Request ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (__props.request.status === 'filled')
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        color: "success",
                        variant: "flat",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('mark-delivered', __props.request)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                              _createTextVNode("mdi-truck-delivery", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[26] || (_cache[26] = _createTextVNode(" Deliver ", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})